import { useMutation } from '@tanstack/react-query';

import { exposedPostCommentMutation } from '~/api/@tanstack/react-query.gen';

export const usePostComment = () => {
  return useMutation({
    ...exposedPostCommentMutation(),
  });
};
